import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import {AutocompleteRenderOptionState} from '@mui/material/Autocomplete/Autocomplete';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export const renderProductOptionItem = (
  props: React.HTMLAttributes<HTMLLIElement>,
  option?: string,
  state: AutocompleteRenderOptionState,
) => {
  return (
    <li {...props}>
      <Checkbox
        icon={icon}
        checkedIcon={checkedIcon}
        style={{marginRight: 8}}
        checked={state.selected}
        tabIndex={-1}
        disableRipple
        inputProps={{'aria-label': option}}
      />
      {option}
    </li>
  );
};
